// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".container[data-v-ff97f970]{display:flex;justify-content:center}", "",{"version":3,"sources":["webpack://./resources/js/components/ReCaptcha.vue"],"names":[],"mappings":"AAEI,4BACI,YAAA,CACA,sBADR","sourcesContent":["\r\n\r\n    .container{\r\n        display: flex;\r\n        justify-content: center;\r\n    }\r\n\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
